import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../../../../me'
import * as variableOverrides from '../../../../../variable-overrides'
import * as currentRendering from '../../feature'

import { getActionsConfig } from './actions'
import { ApiService } from './api.service'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** TODO: Explain what is this */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(ApiService)

  constructor(
    currentRenderingFeature: currentRendering.Feature,
    routerFeature: router.Router,
  ) {
    const variablesFeature = ngCore.inject(variableOverrides.Feature)
    const meFeature = ngCore.inject(me.Feature)

    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Segments',
      parent: currentRenderingFeature,
      selectors: () =>
        new Selectors(this, currentRenderingFeature, routerFeature, meFeature),
    })

    this.registerEffects(
      effects.triggerSegmentRendering(
        currentRenderingFeature,
        variablesFeature,
      ),
      effects.getRenderOnRequest(),
    )
  }
}
